<template>
  <div>
    <h4 class="subheading">{{ $t('headersform.title') }}</h4>
    <v-tabs
      class="elevation-1 mb-2"
      v-if="headers.length"
      grow scroll-bars
      v-model="active">
      <v-tabs-bar slot="activators"
        class="white" light>
        <v-tabs-item
          v-for="(header, i) in headers" :key="i"
          :href="`#header-${i}`"
          ripple>
          {{ header.title }}
        </v-tabs-item>
        <v-tabs-slider></v-tabs-slider>
      </v-tabs-bar>
      <v-tabs-content
        v-for="(header, i) in headers"
        :key="i"
        :id="`header-${i}`">
        <v-parallax :class="{ 'parallax--video': !!header.video }" :src="header.picture || videoPicture" :height="300">
          <div class="slide-actions">
            <v-dialog v-model="header.edit">
              <v-btn icon light primary slot="activator"><v-icon>edit</v-icon></v-btn>
              <header-form
                :value="header"
                @saved="x => updateHeader(x, i)">
              </header-form>
            </v-dialog>
            <v-btn icon light error @click.native.stop="removeHeader(i)"><v-icon>close</v-icon></v-btn>
          </div>
          <v-container>
            <v-layout column justify-space-around align-center fill-height>
              <div class="text-xs-center">
                <h1 class="mt-4 headline white--text">{{ header.title }}</h1>
                <h2 class="subheading white--text">{{ header.subtitle }}</h2>
              </div>
              <v-btn large light class="mb-4 primary" :to="{ path: header.actionHref }">{{ header.actionTitle }}</v-btn>
            </v-layout>
          </v-container>
        </v-parallax>
      </v-tabs-content>
    </v-tabs>
    <v-dialog v-model="popup">
      <v-btn slot="activator" outline primary>{{ $t('headersform.addHeader') }}</v-btn>
      <header-form
        :value="{}"
        @saved="x => addHeader(x)">
      </header-form>
    </v-dialog>
  </div>
</template>

<script>
import HeaderForm from '@/components/HeaderForm'
export default {
  components: {
    HeaderForm
  },
  props: {
    value: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      popup: false,
      headers: [...this.value],
      active: 'header-0'
    }
  },
  computed: {
    videoPicture () {
      return require('@/assets/video.jpg')
    }
  },
  methods: {
    removeHeader (i) {
      const newHeaders = [...this.headers]
      newHeaders.splice(i, 1)
      this.headers = newHeaders
      this.active = `header-${i === 0 ? 0 : i - 1}`
      this.$emit('input', this.headers)
    },
    updateHeader (header, i) {
      delete header.edit
      const newHeaders = [...this.headers]
      newHeaders[i] = header
      this.headers = newHeaders
      this.$emit('input', this.headers)
    },
    addHeader (header) {
      this.popup = false
      this.headers = [
        ...this.headers,
        header
      ]
      this.active = `header-${this.headers.length - 1}`
      this.$emit('input', this.headers)
    }
  }
}
</script>

<style scoped>
  .slide-actions {
    position: absolute;
    top: .5em;
    right: .5em;
  }
</style>

<style>
  .parallax.parallax--video img {
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    transform: none!important;
    background-size: cover;
  }
</style>



// WEBPACK FOOTER //
// src/components/HeadersForm.vue